import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import { StyledPersonInfo } from "./person-info.scss";
import DefaultProps from "./default-props";
import PictureComponent from "/components/core/picture/picture-component";
class PersonInfo extends PureComponent {
    render() {
        const { personImg, name, jobDescription, personPhotoborderRadius } = this.props;
        return /*#__PURE__*/ _jsxs(StyledPersonInfo, {
            className: "person-info",
            children: [
                /*#__PURE__*/ _jsx(PictureComponent, {
                    className: "avatar-image",
                    src: personImg.src,
                    alt: personImg.alt,
                    specificImageStyle: {
                        borderRadius: personPhotoborderRadius
                    }
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "person-text",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "person-name person",
                            children: name
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "job-description person",
                            children: jobDescription
                        })
                    ]
                })
            ]
        });
    }
}
export { PersonInfo as default };
PersonInfo.defaultProps = DefaultProps;
